import portalContext from "@/context/contexts/portal-context";
import React, { useState, Suspense, useContext, useRef, useEffect } from "react";
import Modal from "../Modal";
import EmployeeCode from "./EmployeeCode";
import { getActiveShop } from "@/constants/utility";
import SessionUtils from "@/utility/SessionUtils";
import { warningAlert } from "@/utility/helpers";

const ProtectWithEmployeeCode = ({
  employeeType = "employee",
  showOnRender = true,
  onUpdate,
  user,
  close,
  children,
  useDialogueBox = false,
  isShopSelection = false,
}) => {
  const context = useContext(portalContext);

  const savedEmployee = SessionUtils.getItem("rs_employee");

  const [employee, setEmployee] = useState(() => (employeeType == "admin" ? user : savedEmployee || user));

  const storemode = /true/.test(getActiveShop(context)?.storemode) && !employee;

  const [showEmployeeCode, setShowEmployeeCode] = useState(() => storemode && showOnRender);

  const userRef = useRef();

  useEffect(() => {
    if (!storemode) {
      setShowEmployeeCode(false);
    }
  }, [getActiveShop(context)?.storemode]);

  useEffect(() => {
    if (!userRef.current && savedEmployee?._id) {
      userRef.current = savedEmployee?._id;
      const update = employeeType == "admin" ? user : savedEmployee || user;
      setEmployee((s) => update);
      onUpdate?.(update);
    }
  }, [savedEmployee]);

  const proceedEmployeeCode = () => {
    if (storemode) {
      setShowEmployeeCode((e) => true);
      return false;
    }
    return true;
  };

  const updateEmployee = (employee) => {
    setEmployee((e) => employee);
    setShowEmployeeCode((e) => false);

    employeeType == "employee" && SessionUtils.setItem("rs_employee", employee);

    if (onUpdate) {
      return onUpdate(employee);
    }
  };

  const closeHandler = () => {
    if (close) {
      return close();
    }
    setShowEmployeeCode(false);
  };

  const showEmployeeCodePanel = () => {
    setShowEmployeeCode(true);
    setEmployee(null);
  };

  return (
    <React.Fragment>
      <Suspense fallback={<Modal />}>
        {showEmployeeCode && !employee ? (
          useDialogueBox ? (
            <>
              <EmployeeCode
                employeeType={employeeType}
                updateEmployee={updateEmployee}
                close={closeHandler}
                useDialogueBox={useDialogueBox}
                isShopSelection={isShopSelection}
              />
              {children({
                proceedEmployeeCode,
                close,
                adminEmployee: employee,
                showEmployeeCodePanel,
              })}
            </>
          ) : (
            
            <EmployeeCode employeeType={employeeType} updateEmployee={updateEmployee} close={closeHandler} isShopSelection={isShopSelection}/>
          )
        ) : (
          children({
            proceedEmployeeCode,
            close,
            adminEmployee: employee,
            showEmployeeCodePanel,
          })
        )}
      </Suspense>
    </React.Fragment>
  );
};

export default ProtectWithEmployeeCode;
